// Static (non-text) data: images, icons, ids, contact info.
// All human-readable text lives in i18n/translations.js keyed by index.

export const CONTACT_INFO = {
  displayEmail: 'reachus@argecosmetics.co.uk', // MOCKED display address
  phone: '+44 7480 205061',
  addressLine: '7A Hill Rise, Upminster, RM14 2RA, United Kingdom',
  hqLine: 'Production HQ: Istanbul, T\u00fcrkiye',
  instagram: 'https://www.instagram.com/argekozmetik/',
  linkedin: 'https://www.linkedin.com/company/113125064/',
  facebook: 'https://www.facebook.com/share/1B8VVeXvon/',
  youtube: 'https://www.youtube.com/channel/UCIS4XVT614lWV_u4OKkha9g',
};

// Social platforms (icons resolved via lucide by name)
export const SOCIALS = [
  { name: 'Instagram', icon: 'Instagram', handle: '@argekozmetik', url: 'https://www.instagram.com/argekozmetik/' },
  { name: 'LinkedIn', icon: 'Linkedin', handle: 'ARGE Cosmetics', url: 'https://www.linkedin.com/company/113125064/' },
  { name: 'Facebook', icon: 'Facebook', handle: 'ARGE Cosmetics', url: 'https://www.facebook.com/share/1B8VVeXvon/' },
  { name: 'YouTube', icon: 'Youtube', handle: 'ARGE Cosmetics', url: 'https://www.youtube.com/channel/UCIS4XVT614lWV_u4OKkha9g' },
];

// Hero + editorial imagery
// Self-hosted original luxury imagery (AI-generated, unbranded, copyright-safe).
export const IMAGES = {
  // Hero / editorial
  heroBottle: '/images/skincare_hero.jpg',
  serumSplash: '/images/serum_splash.jpg',
  bottlesNeutral: '/images/personal_care.jpg',
  bottlesGroup: '/images/sun_care.jpg',
  lab: '/images/lab.jpg',
  manufacturing: '/images/manufacturing.jpg',
  formula: '/images/formula.jpg',
  packaging: '/images/packaging.jpg',
  portfolio: '/images/portfolio.jpg',
  // Product category imagery
  skincare: '/images/skincare_hero.jpg',
  baby: '/images/baby.jpg',
  personalCare: '/images/personal_care.jpg',
  sunCare: '/images/sun_care.jpg',
  socialVisual: '/images/social_visual.jpg',
};

// Stat values (numbers are language-agnostic)
export const STATS = [
  { value: '15+', key: 'expertise' },
  { value: '300+', key: 'brands' },
  { value: '1200+', key: 'formulas' },
  { value: '40+', key: 'countries' },
];

// Service icons (lucide names) aligned by index with translations.services.items
export const SERVICE_ICONS = ['FlaskConical', 'Factory', 'Sparkles', 'ShieldCheck', 'Package', 'FileCheck', 'Rocket'];

// Product category images aligned by index with translations.products.categories
// [Skincare, Haircare, Body & Personal Care, Baby & Sensitive, Sun & Men's]
export const PRODUCT_IMAGES = [
  IMAGES.skincare,
  IMAGES.personalCare,
  IMAGES.socialVisual,
  IMAGES.baby,
  IMAGES.sunCare,
];

// Process step icons aligned with translations.rnd.steps
export const PROCESS_ICONS = ['Lightbulb', 'FlaskConical', 'Palette', 'ClipboardCheck', 'Factory', 'Truck'];

// Certificate icons aligned with translations.certs.items
export const CERT_ICONS = ['Award', 'ShieldCheck', 'Leaf', 'Globe2'];

// Why-us icons aligned with translations.home.whyItems
export const WHY_ICONS = ['Microscope', 'ShieldCheck', 'Layers', 'HandshakeIcon', 'Recycle', 'Boxes'];

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '\ud83c\uddec\ud83c\udde7', dir: 'ltr' },
  { code: 'fr', label: 'Fran\u00e7ais', flag: '\ud83c\uddeb\ud83c\uddf7', dir: 'ltr' },
  { code: 'es', label: 'Espa\u00f1ol', flag: '\ud83c\uddea\ud83c\uddf8', dir: 'ltr' },
  { code: 'de', label: 'Deutsch', flag: '\ud83c\udde9\ud83c\uddea', dir: 'ltr' },
  { code: 'ar', label: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', flag: '\ud83c\uddf8\ud83c\udde6', dir: 'rtl' },
  { code: 'hi', label: '\u0939\u093f\u0928\u094d\u0926\u0940', flag: '\ud83c\uddee\ud83c\uddf3', dir: 'ltr' },
  { code: 'tr', label: 'T\u00fcrk\u00e7e', flag: '\ud83c\uddf9\ud83c\uddf7', dir: 'ltr' },
  { code: 'pt', label: 'Portugu\u00eas', flag: '\ud83c\uddf5\ud83c\uddf9', dir: 'ltr' },
];
